module.exports = __webpack_public_path__ + "static/media/bhim-sbi.bd722959.png";